import React from 'react';
import { Translation } from 'react-i18next';

import { Link } from 'react-router-dom';

import BillingDetailsContent
  from 'components/dashboard/billing-content/BillingDetailsContent';
import BillingInvoicesContent
  from 'components/dashboard/billing-content/BillingInvoicesContent';

import './BillingDetailsPageContent.css';

const BillingDetailsPageContent = () => (
  <Translation>
    {(t) => (
      <div className="billing-details-page-content__component">
        <BillingDetailsContent />
        <BillingInvoicesContent />
        <div className="back-to-billing">
          <div className="icon" />
          <Link to="/billing/subscription">
            {t("Back to Billing")}
          </Link>
        </div>
      </div>
    )}
  </Translation>
);

export default BillingDetailsPageContent;
